import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import type { SelectChangeEvent } from '@mui/material/Select';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import type InspectingCompany from '../../InspectingCompanyModel';

class InspectingCompanyChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.INSPECTING_COMPANY);
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, inspectingCompanies: InspectingCompany[], inspectingCompanyMenuItems: JSX.Element[], screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <FormControl 
                    size='small'
                    style={{
                        width: Math.min(screenWidth * 0.8, 500),
                    }}
                >
                    <InputLabel>{this.name}</InputLabel>
                    <Select
                        value={value}
                        onChange={async (e: SelectChangeEvent): Promise<void> => onChange((e.target as HTMLInputElement).value)}
                        size='small'
                        variant='outlined'
                        label={this.name}
                    >
                        <MenuItem 
                            key='__empty__'
                            value=''
                        >
                            &nbsp;
                        </MenuItem>
                        {value !== '' && !inspectingCompanies.map((inspectingCompany: InspectingCompany) => inspectingCompany.companyId).includes(value) && //allows removed options to still be there until changed
                            <MenuItem 
                                key='__current__'
                                value={value}
                                disabled={true}
                            >
                                {value}
                            </MenuItem>
                        }
                        {inspectingCompanyMenuItems}
                    </Select>
                </FormControl>
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default InspectingCompanyChecklistElement;